<script setup>
import { inject, computed, ref, onMounted, onUnmounted } from 'vue'
import { useElementBounding } from '@vueuse/core'

import ToastNotification from '@dogfy/components/widgets/ToastNotification.vue'

const props = defineProps({
  // The top element to consider top positioning.
  // Usefull when toasts are required to appear under the AppHeader.
  topElement: {
    type: String,
    default: null,
  },
})

const { toasts, removeToast, removeAllToasts } = inject('toast')

const topElementRef = ref(null)
const topElementBounding = useElementBounding(topElementRef)
const topPositioning = computed(() => topElementBounding.top.value + topElementBounding.height.value)

// FIXME: What is required is: when changing layout, then remove toasts.
// watch(() => route.name, () => {
//   removeAllToasts()
// })

onMounted(() => {
  if (props.topElement) {
    topElementRef.value = document.querySelector(props.topElement)
  }
})

onUnmounted(() => {
  removeAllToasts()
})
</script>

<template>
  <div class="toasts-container">
    <TransitionGroup tag="div" class="toasts-container__container" name="toast">
      <ToastNotification
        v-for="[toastId, toast] in toasts"
        :key="toastId"
        class="toasts-container__toast"
        :actions="toast.actions"
        :button="toast.button"
        :second-button="toast.secondButton"
        :options="toast.options"
        :type="toast.type"
        @close="removeToast(toastId)"
      >
        {{ toast.message }}
      </ToastNotification>
    </TransitionGroup>
  </div>
</template>

<style lang="scss">
.toasts-container {
  position: fixed;
  z-index: z-number(toast);
  top: calc(v-bind(topPositioning)*1px);
  bottom: 0;
  left: 50%;

  display: grid;
  transform: translateX(-50%);

  grid-template-columns: 1fr;
  gap: $spacer;

  box-sizing: border-box;
  padding: $spacer*1.5 $spacer;
  width: 100%;
  max-width: $max-content-width;

  pointer-events: none;

  @include breakpoint(md) {
    grid-template-columns: 1fr 1fr;
    gap: $spacer*1.5;

    padding: $spacer*1.5;
  }

  @include breakpoint(lg) {
    padding: $spacer $spacer*3;
  }

  &__container {
    position: relative;

    width: 100%;

    @include breakpoint(md) {
      grid-column-start: 2;
    }
  }

  &__toast {
    margin-left: auto;

    &:not(:last-of-type) {
      margin-bottom: $spacer;
    }
  }
}

.toast-move,
.toast-enter-active,
.toast-leave-active {
  transition: all $transition-duration-slowest ease;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateX(35%);
}

.toast-leave-active {
  position: absolute;
  right: 0;
}
</style>
